import { useTranslation } from "react-i18next";

export const LanguageToggle = () => {
  const { i18n } = useTranslation();
  const current = (i18n.resolvedLanguage || i18n.language || "fr").slice(0, 2);

  const switchTo = (lng) => {
    i18n.changeLanguage(lng);
  };

  return (
    <div
      data-testid="language-switcher"
      className="inline-flex items-center gap-0.5 rounded-full border border-slate-200 bg-white/80 p-0.5 text-xs font-medium"
    >
      {["fr", "en"].map((lng) => {
        const active = current === lng;
        return (
          <button
            key={lng}
            data-testid={`lang-${lng}`}
            onClick={() => switchTo(lng)}
            className={`rounded-full px-3 py-1.5 uppercase tracking-wider transition-all ${
              active
                ? "bg-slate-900 text-white shadow-sm"
                : "text-slate-500 hover:text-slate-900"
            }`}
            aria-pressed={active}
          >
            {lng}
          </button>
        );
      })}
    </div>
  );
};

export default LanguageToggle;
